// Strings for the tool pages (Monte Carlo, calculators, holdings watch, pricing, paper analyser), kept apart from the
// main dictionaries so the globe page doesn't carry them. Only English and the visitor's language are downloaded.
import { extend, lang } from './index.js';

const LOADERS = import.meta.glob('./tools/*.js');

export async function loadToolStrings() {
    try {
        const en = (await LOADERS['./tools/en.js']()).default;
        const own = lang === 'en' || !LOADERS[`./tools/${lang}.js`] ? en : (await LOADERS[`./tools/${lang}.js`]()).default;
        extend(own, en);
    } catch (err) {
        console.error('[i18n] tool strings failed to load', err);
    }
}
